import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getmsgSharList, delemsgSharing } from "@/api/dataAll/msgSharing";
import addClassfiy from "./components/addClassfiy";
export default {
  name: "inforShareMsg",
  components: {
    addClassfiy: addClassfiy
  },
  data: function data() {
    return {
      total: 0,
      pagrSize: 10,
      searchData: {
        page: 1
      },
      searchMark: {
        page: ""
      },
      tableData: [],
      addWayConfig: false,
      showing: false
    };
  },
  created: function created() {
    this.searchClick();
  },
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      getmsgSharList(this.searchMark).then(function (res) {
        _this.tableData = res.data.data || [];
        _this.total = res.data.total - 0 || 0;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this2 = this;

      this.addWayConfig = true;
      this.showing = true;
      this.$nextTick(function () {
        _this2.$refs.addWayConfig.init(id, num);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delemsgSharing({
                  id: id
                }).then(function (res) {
                  _this3.searchClick();
                });

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};